module.exports = __webpack_public_path__ + "static/media/SG.deda0817.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/SG.svg
// module id = 2257
// module chunks = 7